import React, { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { db } from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import { Table, Input, Select } from 'antd';
import { auth } from '../../firebase/firebase-config';
import BeatLoader from "react-spinners/BeatLoader";
import "tippy.js/dist/tippy.css";
import { getAllFacilities } from "../../services/facilities";
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import './facility-maps.css';
const { Search } = Input;
const { Option } = Select;

const override = {
  marginTop: "20px",
};


function Index() {
  const [allFacilities, setAllFacilities] = useState<any[]>([]);
  const [facilityTypes, setFacilityTypes] = useState<string[]>([]);
  const [selectedType, setSelectedType] = useState<string>('');
  const [groupedFacilities, setGroupedFacilities] = useState<any>({});
  const [mapCenter, setMapCenter] = useState({
    lat: 3.8252847,
    lng: 11.5170652
  });
  const [loading, setLoading] = useState(false);
  const [sortedInfo, setSortedInfo] = useState<any>({});
  const [user] = useAuthState(auth);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
  });

  // Validate coordinates helper
  const isValidCoordinates = (coords: any): boolean => {
    return coords && 
           typeof coords.latitude === 'number' && 
           typeof coords.longitude === 'number' &&
           !isNaN(coords.latitude) && 
           !isNaN(coords.longitude);
  };

  const getCustomMarkerIcon = (iconUrl: string) => {
    // console.log('icon urls: ', iconUrl)
    if (!iconUrl) return '';
    
    try {
      return {
        url: iconUrl,
        scaledSize: new google.maps.Size(32, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 16),
      };
    } catch (error) {
      console.error('Error creating marker icon:', error);
      return '';
    }
  };

  // Group facilities by type when data is fetched
  useEffect(() => {
    if (allFacilities.length > 0) {
      const grouped = allFacilities.reduce((acc: any, facility) => {
        // Add null check for facility and facilityType
        const type = facility?.facilityType;
        if (type && isValidCoordinates(facility?.coordinates)) {
          if (!acc[type]) {
            acc[type] = [];
          }
          acc[type].push(facility);
        }
        return acc;
      }, {});

      console.log('GROUPED FACILITIES: ', grouped);
      setGroupedFacilities(grouped);
      const types = Object.keys(grouped);
      setFacilityTypes(types);
      if (types.length > 0) {
        setSelectedType(types[0]); // Select first type by default
      }
    }
  }, [allFacilities]);

  // Update map center when type changes
  useEffect(() => {
    if (selectedType && groupedFacilities[selectedType]?.length > 0) {
      const facilities = groupedFacilities[selectedType];
      const firstFacility = facilities[0];
      if (isValidCoordinates(firstFacility?.coordinates)) {
        setMapCenter({
          lat: firstFacility.coordinates.latitude,
          lng: firstFacility.coordinates.longitude
        });
      }
    }
  }, [selectedType]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: any = await getAllFacilities();
      setAllFacilities(res?.data?.facilities || []);
    } catch (error) {
      console.error('Error fetching facilities:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    console.log('ALL FACILITIES: ', allFacilities);
  }, [allFacilities]);

  allFacilities.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  return (
    <>
      <Layout title="Facility Map" pageTitle="All Facilities Map">
        <div className="section">
          <div className="parent-con">
            <div className="data-table">
              <div className="top">
                <div className="span">
                  <h3>Maps</h3>
                </div>
                <div className="facility-type-selector">
                  <Select
                    value={selectedType}
                    onChange={setSelectedType}
                    style={{ width: 200 }}
                    className="custom-select"
                  >
                    {facilityTypes.map(type => (
                      <Option key={type} value={type}>
                        {type} ({groupedFacilities[type]?.length || 0})
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="map-container">
                {isLoaded ? (
                  <GoogleMap
                    mapContainerClassName="google-map"
                    center={mapCenter}
                    zoom={13}
                    options={{
                      fullscreenControl: true,
                      streetViewControl: false,
                      mapTypeControl: true,
                      zoomControl: true,
                    }}
                  >
                    {selectedType && 
                     groupedFacilities[selectedType]?.filter((facility: any) => 
                       facility && isValidCoordinates(facility.coordinates)
                     ).map((facility: any) => (
                      <Marker
                        key={facility.id || Math.random().toString()}
                        position={{
                          lat: facility.coordinates.latitude,
                          lng: facility.coordinates.longitude
                        }}
                        icon={getCustomMarkerIcon(facility.facilityIcon)}
                        title={facility.facilityName || ''}
                        options={{
                          optimized: true,
                          clickable: true,
                        }}
                      />
                    ))}
                  </GoogleMap>
                ) : (
                  <div className="map-loader">
                    <BeatLoader color="#3080ED" />
                    <div>Loading map...</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Index;


